
import { Component, Vue } from 'vue-property-decorator'
import BigScreen from './BigScreen.vue'
import SmallScreen from './SmallScreen.vue'
import utilsManager from '@/utils-center'

@Component({
  components: {
    BigScreen,
    SmallScreen
  }
})
export default class App extends Vue {
  private isMobile = false

  mounted () {
    this.isMobile = utilsManager.judgeIsMobile()
  }
}
